import { useEffect } from 'react';

import { queriesSentWithoutDeviceFingerprint } from '#src/contexts/deviceFingerprint/index.ts';

type Args = {
  loading: boolean;
  signedIn: boolean;
  hasDeviceFingerprint: boolean;
  refetch: () => Promise<unknown>;
};

// ConfigQuery sent before the fingerprint was known has wrong device fields
// (confirmedDevice, currentDevice). If the fingerprint fails, nothing refetches.
export const useRefetchConfigWithDeviceFingerprint = ({
  loading,
  signedIn,
  hasDeviceFingerprint,
  refetch,
}: Args) => {
  useEffect(() => {
    if (
      loading ||
      !hasDeviceFingerprint ||
      !queriesSentWithoutDeviceFingerprint.current
    ) {
      return;
    }
    queriesSentWithoutDeviceFingerprint.current = false;
    if (signedIn) {
      // An unmount aborts the refetch; the next ConfigQuery heals it anyway.
      refetch().catch(() => {});
    }
  }, [loading, signedIn, hasDeviceFingerprint, refetch]);
};
